// extracted by mini-css-extract-plugin
export default {"cls1":"FreeformQuestion-cls1___4ca2e1675dfcb20b831","cls2":"FreeformQuestion-cls2__bed30beaeb87e03b3323 FreeformQuestion-cls1___4ca2e1675dfcb20b831"};